import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DateAdapter } from '@angular/material/core';
import { CommonService } from '@tech-services/common.service';
import { DialogDataInterface } from '../modal-custom-date/dialog-data.interface';
import {
  ProfileportfolioService,
  DocmanagerService,
  TechDropdownItemInterface,
} from '@techrules/portallib';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'tech-modal-custom-account-statement',
  templateUrl: './modal-custom-account-statement.component.html',
  styleUrls: ['./modal-custom-account-statement.component.scss'],
})
export class ModalCustomAccountStatementComponent implements OnInit {
  public arrdata: any;
  selectedDocumentId: string;
  selectedDocument: any;
  disableConfirm: boolean = false;
  public showAccountStatementDocuments: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ModalCustomAccountStatementComponent>,
    private _adapter: DateAdapter<any>,
    private commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataInterface,
    private profilePortfolioService: ProfileportfolioService,
    private translate: TranslateService,
    private docmanagerService: DocmanagerService
  ) {}

  ngAfterViewInit(): void {}

  ngOnInit() {
    setTimeout(() => {
      this.commonService.loading$.emit(true);
      this.docmanagerService
        .getAccountStatementDocuments(this.data.portfolioCode)
        .subscribe((data) => {
          this.arrdata = data.AccountStatementDocuments;
          this.showAccountStatementDocuments = this.arrdata.length !== 0;
          this.commonService.loading$.emit(false);
        },
      (err) => {
          this.commonService.errorManager('getAccountStatementDocuments', err);
          this.commonService.loading$.next(false);
          this.dialogRef.close();
        });
    });
  }

  onDocumentChange(e) {
    const doc = this.arrdata.find((d) => d.Id == e.value);
    this.selectedDocument = doc;
  }
}
